export class User {
  firstName: string
  lastName: string

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(json: any) {
    this.firstName = json.firstName
    this.lastName = json.lastName
  }
}
